// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/editor.scss
// module id = 2
// module chunks = 0 1